import {
  BankOutlined,
  BarChartOutlined,
  BookOutlined,
  BranchesOutlined,
  CalendarOutlined,
  ClusterOutlined,
  ContactsOutlined,
  ControlOutlined,
  CrownOutlined,
  FilterOutlined,
  FormatPainterOutlined,
  GiftOutlined,
  GroupOutlined,
  HomeOutlined,
  MoneyCollectOutlined,
  ProfileOutlined,
  ScheduleOutlined,
  SettingOutlined,
  SnippetsOutlined,
  TagsOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ActionsHistoryPage,
  AddBranch,
  AddChain,
  AddClient,
  AddEmployee,
  AddPaymentsAccount,
  AddPosition,
  AddServiceCategory,
  AddUser,
  Authorization,
  BranchesList,
  CalendarSettings,
  ChainsList,
  ClientsList,
  ControlPanel,
  DataMigration,
  DataMigrationHeader,
  DataMigrationViewer,
  DocumentTemplates,
  EditClientService,
  EditEmployee,
  EditSalesFunnel,
  EditSalesFunnelPageHeader,
  EditUser,
  EmailChange,
  EmployeesList,
  FinancialOperations,
  Integrations,
  IntegrationsPageHeader,
  McpIntegration,
  ProxyIntegration,
  LegalEntities,
  LogsRegistry,
  ManageMessageTemplate,
  Messages,
  MessageTemplatesRegistry,
  PaymentAccounts,
  PaymentAccountsPageHeader,
  Positions,
  Records,
  RecordsPageHeader,
  SalePlans,
  SalesFunnels,
  SalesFunnelsPageHeader,
  ServiceCategories,
  ServicesSortingHeader,
  Settings,
  SortEmployees,
  Tags,
  ClientFields,
  TaskListPage,
  TaskListPageHeader,
  UserProfile,
  UsersList,
  ViewSalesFunnel,
  ViewSalesFunnelPageHeader,
  WorkSchedule,
  Analytics,
  IntegrationParsing,
  SettingUpAutomaticMessagingToClients,
  RecordNotifications,
  AiPromptsSettings,
  PaidAiFeatures,
  NeuralNetworkLogs,
  EmailLogs,
  YooKassaSuccessPayment,
  PaymentDocumentsRegistryHeader,
  PaymentDocumentsRegistry,
  AddPaymentDocument,
  YooKassaPaymentWithEmail,
  CalendarHeader,
  CalendarPage,
  IndividualCalendarHeader,
  IndividualCalendarPage,
  ClientLeadCardPage,
  MedicalCardRegistry,
} from '@pages';

import {
  Error404NotFound,
  Page,
  HealthCheck,
  LayoutLogin,
  RecordModal,
} from '@app/components';
import type { NPage } from '@app/components/Page/types/Page.main';
import {
  ACTIONS_HISTORY,
  ACTIONS_HISTORY_KEY,
  ACTIONS_HISTORY_LABEL,
  ACTIONS_HISTORY_PATH,
  ADD_BRANCH,
  ADD_BRANCH_KEY,
  ADD_BRANCH_LABEL,
  ADD_CATEGORY,
  ADD_CATEGORY_KEY,
  ADD_CATEGORY_LABEL,
  ADD_CATEGORY_PATH,
  ADD_CHAIN,
  ADD_CHAIN_KEY,
  ADD_CHAIN_LABEL,
  ADD_CLIENT,
  ADD_CLIENT_KEY,
  ADD_CLIENT_LABEL,
  ADD_CLIENT_SERVICES_LABEL,
  ADD_EMPLOYEE,
  ADD_EMPLOYEE_KEY,
  ADD_EMPLOYEES_LABEL,
  ADD_LEGAL_ENTITY,
  ADD_LEGAL_ENTITY_KEY,
  ADD_LEGAL_ENTITY_LABEL,
  ADD_LEGAL_ENTITY_PATH,
  ADD_PAYMENT_ACCOUNT,
  ADD_PAYMENT_ACCOUNT_KEY,
  ADD_PAYMENT_ACCOUNT_LABEL,
  ADD_PAYMENT_ACCOUNT_PATH,
  ADD_POSITION,
  ADD_POSITION_KEY,
  ADD_POSITION_LABEL,
  ADD_POSITION_PATH,
  ADD_SERVICE,
  ADD_SERVICE_KEY,
  ADD_SERVICE_PATH,
  ADD_USER_ID,
  ADD_USER_KEY,
  ADD_USER_LABEL,
  ANALYTICS,
  ANALYTICS_KEY,
  ANALYTICS_LABEL,
  ANALYTICS_PATH,
  AUTHORIZATION,
  AUTHORIZATION_PATH,
  BRANCHES,
  BRANCHES_KEY,
  BRANCHES_LABEL,
  BRANCHES_PATH,
  BRANCHES_PREVIEW,
  BRANCHES_PREVIEW_KEY,
  BRANCHES_PREVIEW_LABEL,
  BRANCHES_PREVIEW_PATH,
  CALENDAR,
  CALENDAR_KEY,
  CALENDAR_PATH,
  CATEGORIES,
  CATEGORIES_KEY,
  CATEGORIES_LABEL,
  CATEGORIES_PATH,
  CHAINS_ID,
  CHAINS_KEY,
  CHAINS_LABEL,
  CHAINS_PATH,
  CLIENT_CARD,
  CLIENT_CARD_KEY,
  CLIENT_CARD_LABEL,
  CLIENT_CARD_PATH,
  CLIENT_PAYMENTS,
  CLIENT_PAYMENTS_KEY,
  CLIENT_PAYMENTS_PATH,
  CLIENT_SERVICES,
  CLIENT_SERVICES_KEY,
  CLIENT_SERVICES_LABEL,
  CLIENT_SERVICES_PATH,
  CLIENTS,
  CLIENTS_KEY,
  CLIENTS_LABEL,
  CLIENTS_PATH,
  CONTROL_PANEL,
  CONTROL_PANEL_KEY,
  CONTROL_PANEL_LABEL,
  CONTROL_PANEL_PATH,
  DATA_MIGRATION,
  DATA_MIGRATION_KEY,
  DATA_MIGRATION_LABEL,
  DATA_MIGRATION_PATH,
  DATA_TESTID_ATTRIBUTE,
  EDIT_BRANCH,
  EDIT_BRANCH_KEY,
  EDIT_BRANCH_LABEL,
  EDIT_CATEGORY_KEY,
  EDIT_CATEGORY_LABEL,
  EDIT_CATEGORY_PATH,
  EDIT_CHAIN,
  EDIT_CHAIN_LABEL,
  EDIT_CLIENT,
  EDIT_CLIENT_KEY,
  EDIT_CLIENT_LABEL,
  EDIT_CLIENT_SERVICES,
  EDIT_CLIENT_SERVICES_LABEL,
  EDIT_EMPLOYEE,
  EDIT_EMPLOYEE_KEY,
  EDIT_EMPLOYEE_LABEL,
  EDIT_EMPLOYEE_PATH,
  EDIT_LEGAL_ENTITY,
  EDIT_LEGAL_ENTITY_KEY,
  EDIT_LEGAL_ENTITY_LABEL,
  EDIT_LEGAL_ENTITY_PATH,
  EDIT_PAYMENT_ACCOUNT,
  EDIT_PAYMENT_ACCOUNT_KEY,
  EDIT_PAYMENT_ACCOUNT_LABEL,
  EDIT_PAYMENT_ACCOUNT_PATH,
  EDIT_POSITION,
  EDIT_POSITION_KEY,
  EDIT_POSITION_LABEL,
  EDIT_POSITION_PATH,
  EDIT_SALES_FUNNEL,
  EDIT_SALES_FUNNEL_KEY,
  EDIT_SALES_FUNNEL_LABEL,
  EDIT_SALES_FUNNEL_PATH,
  EDIT_SERVICE_CATEGORY,
  EDIT_SERVICE_KEY,
  EDIT_SERVICE_PATH,
  EDIT_USER,
  EDIT_USER_KEY,
  EDIT_USER_LABEL,
  EMAIL_VERIFICATION,
  EMAIL_VERIFICATION_LABEL,
  EMAIL_VERIFICATION_PATH,
  EMPLOYEES,
  EMPLOYEES_KEY,
  EMPLOYEES_LABEL,
  EMPLOYEES_PATH,
  ERROR_404,
  ERROR_404_LABEL,
  FILE_EXPORT,
  FILE_EXPORT_KEY,
  FILE_EXPORT_LABEL,
  FILE_EXPORT_PATH,
  FINANCES_LABEL,
  HEALTH_CHECK,
  HOME_PAGE_PATH,
  IMPORT_CLIENTS,
  IMPORT_CLIENTS_KEY,
  IMPORT_CLIENTS_LABEL,
  IMPORT_CLIENTS_PATH,
  IMPORT_EMPLOYEES,
  IMPORT_EMPLOYEES_KEY,
  IMPORT_EMPLOYEES_LABEL,
  IMPORT_EMPLOYEES_PATH,
  IMPORT_RECORDS,
  IMPORT_RECORDS_KEY,
  IMPORT_RECORDS_LABEL,
  IMPORT_RECORDS_PATH,
  IMPORT_SERVICES,
  IMPORT_SERVICES_KEY,
  IMPORT_SERVICES_LABEL,
  IMPORT_SERVICES_PATH,
  INDIVIDUAL_CALENDAR,
  INDIVIDUAL_CALENDAR_KEY,
  INDIVIDUAL_CALENDAR_PATH,
  INTEGRATIONS,
  INTEGRATIONS_KEY,
  INTEGRATIONS_LABEL,
  INTEGRATIONS_PATH,
  MCP_INTEGRATION,
  MCP_INTEGRATION_LABEL,
  MCP_INTEGRATION_PATH,
  PROXY,
  PROXY_LABEL,
  PROXY_ROUTE_PATH,
  LEGAL_ENTITIES_ID,
  LEGAL_ENTITIES_KEY,
  LEGAL_ENTITIES_LABEL,
  LEGAL_ENTITIES_PATH,
  MESSAGES,
  MESSAGES_KEY,
  MESSAGES_LABEL,
  MESSAGES_PATH,
  MIGRATION_CARD,
  MIGRATION_CARD_KEY,
  MIGRATION_CARD_LABEL,
  MIGRATION_CARD_PATH,
  NO_TOOLTIP_TITLE,
  OPERATIONS,
  OPERATIONS_KEY,
  OPERATIONS_LABEL,
  OPERATIONS_PATH,
  ORGANIZATION_AI_SETTINGS,
  ORGANIZATION_AI_SETTINGS_KEY,
  ORGANIZATION_AI_SETTINGS_LABEL,
  ORGANIZATION_AI_SETTINGS_PATH,
  ORGANIZATION_SETTINGS,
  ORGANIZATION_SETTINGS_KEY,
  ORGANIZATION_SETTINGS_LABEL,
  ORGANIZATION_USERS,
  ORGANIZATION_USERS_KEY,
  ORGANIZATION_USERS_LABEL,
  ORGANIZATIONS,
  ORGANIZATIONS_KEY,
  ORGANIZATIONS_LABEL,
  ORGANIZATIONS_PATH,
  PAYMENTS_ACCOUNTS,
  PAYMENTS_ACCOUNTS_KEY,
  PAYMENTS_ACCOUNTS_LABEL,
  PAYMENTS_ACCOUNTS_PATH,
  POSITIONS,
  POSITIONS_KEY,
  POSITIONS_LABEL,
  POSITIONS_PATH,
  PROFILE,
  PROFILE_KEY,
  PROFILE_LABEL,
  PROFILE_PATH,
  RECORDS,
  RECORDS_JOURNAL_LABEL,
  RECORDS_KEY,
  RECORDS_LABEL,
  RECORDS_PATH,
  REGISTRATION,
  REGISTRATION_PATH,
  RIGHTS_ANALYTICS,
  RIGHTS_BRANCHES,
  RIGHTS_CHAINS,
  RIGHTS_CLIENTS,
  RIGHTS_SALES_REGISTER,
  RIGHTS_RECORDS,
  RIGHTS_MEDICAL_DOCUMENTS,
  RIGHTS_SALES_FUNNELS,
  RIGHTS_SENDOUTS,
  RIGHTS_CRM_TASKS,
  RIGHTS_USERS,
  RIGHTS_WORK_SCHEDULES,
  SALE_PLANS_ID,
  SALE_PLANS_KEY,
  SALE_PLANS_LABEL,
  SALE_PLANS_PATH,
  SALES_FUNNELS_KEY,
  SALES_FUNNELS_LABEL,
  SALES_FUNNELS_PATH,
  SCHEDULE,
  SCHEDULE_KEY,
  SCHEDULE_PATH,
  SENDOUT_RECEIVERS,
  SENDOUT_RECEIVERS_KEY,
  SENDOUT_RECEIVERS_LABEL,
  SENDOUT_RECEIVERS_PATH,
  SENDOUTS,
  SENDOUTS_KEY,
  SENDOUTS_LABEL,
  SENDOUTS_PATH,
  SETTINGS,
  SETTINGS_KEY,
  SETTINGS_LABEL,
  SETTINGS_PATH,
  SORT_EMPLOYEES,
  SORT_EMPLOYEES_KEY,
  SORT_EMPLOYEES_LABEL,
  SORT_EMPLOYEES_PATH,
  TAGS,
  TAGS_KEY,
  TAGS_LABEL,
  TAGS_PATH,
  CLIENT_FIELDS,
  CLIENT_FIELDS_KEY,
  CLIENT_FIELDS_LABEL,
  CLIENT_FIELDS_PATH,
  SUBSCRIPTIONS,
  SUBSCRIPTIONS_KEY,
  SUBSCRIPTIONS_LABEL,
  SUBSCRIPTIONS_PATH,
  CERTIFICATES,
  CERTIFICATES_KEY,
  CERTIFICATES_LABEL,
  CERTIFICATES_PATH,
  TASK_LIST,
  TASK_LIST_KEY,
  TASK_LIST_LABEL,
  TASK_LIST_PATH,
  USER_PROFILE,
  USERS,
  USERS_KEY,
  USERS_LABEL,
  USERS_PATH,
  VIEW_SALES_FUNNEL,
  VIEW_SALES_FUNNEL_KEY,
  VIEW_SALES_FUNNEL_LABEL,
  VIEW_SALES_FUNNEL_PATH,
  VIEW_SENDOUTS,
  VIEW_SENDOUTS_KEY,
  VIEW_SENDOUTS_LABEL,
  VIEW_SENDOUTS_PATH,
  WORK_SCHEDULES_LABEL,
  MESSAGE_TEMPLATES,
  MESSAGE_TEMPLATES_LABEL,
  MESSAGE_TEMPLATES_KEY,
  MESSAGE_TEMPLATES_PATH,
  ADD_MESSAGE_TEMPLATE_LABEL,
  ADD_MESSAGE_TEMPLATE,
  ADD_MESSAGE_TEMPLATE_PATH,
  ADD_MESSAGE_TEMPLATE_KEY,
  EDIT_MESSAGE_TEMPLATE,
  EDIT_MESSAGE_TEMPLATE_KEY,
  EDIT_MESSAGE_TEMPLATE_LABEL,
  EDIT_MESSAGE_TEMPLATE_PATH,
  CALENDAR_SETTINGS_PATH,
  CALENDAR_SETTINGS_KEY,
  CALENDAR_SETTINGS_LABEL,
  CALENDAR_SETTINGS_ID,
  LOGS_REGISTRY_KEY,
  LOGS_REGISTRY_LABEL,
  LOGS_REGISTRY,
  LOGS_REGISTRY_PATH,
  NOTIFICATIONS,
  NOTIFICATIONS_KEY,
  NOTIFICATIONS_LABEL,
  NOTIFICATIONS_PATH,
  EDIT_CLIENT_PATH,
  EDIT_SENDOUTS_KEY,
  EDIT_SENDOUTS_LABEL,
  EDIT_SENDOUTS,
  EDIT_SENDOUTS_PATH,
  INTEGRATIONS_PARSING_KEY,
  INTEGRATIONS_PARSING_LABEL,
  INTEGRATIONS_PARSING,
  SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_KEY,
  SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_LABEL,
  SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS,
  SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_PATH,
  AI_PROMPTS_SETTINGS_KEY,
  AI_PROMPTS_SETTINGS_LABEL,
  AI_PROMPTS_SETTINGS,
  AI_PROMPTS_SETTINGS_PATH,
  PAID_AI_FEATURES_KEY,
  PAID_AI_FEATURES_LABEL,
  PAID_AI_FEATURES,
  PAID_AI_FEATURES_PATH,
  NEURAL_NETWORK_LOGS_SETTINGS_KEY,
  NEURAL_NETWORK_LOGS_SETTINGS_LABEL,
  NEURAL_NETWORK_LOGS_SETTINGS,
  NEURAL_NETWORK_LOGS_SETTINGS_PATH,
  EMAIL_LOGS_SETTINGS_KEY,
  EMAIL_LOGS_SETTINGS_LABEL,
  EMAIL_LOGS_SETTINGS,
  EMAIL_LOGS_SETTINGS_PATH,
  YOO_KASSA_SUCCESS_PAYMENT_LABEL,
  YOO_KASSA_SUCCESS_PAYMENT,
  YOO_KASSA_SUCCESS_PAYMENT_PATH,
  PAYMENT_DOCUMENTS_PATH,
  PAYMENT_DOCUMENTS,
  PAYMENT_DOCUMENTS_LABEL,
  PAYMENT_DOCUMENTS_KEY,
  ADD_PAYMENT_DOCUMENTS_PATH,
  ADD_PAYMENT_DOCUMENTS,
  ADD_PAYMENT_DOCUMENTS_LABEL,
  ADD_PAYMENT_DOCUMENTS_KEY,
  YOO_KASSA_PAYMENT_WITH_EMAIL,
  YOO_KASSA_PAYMENT_WITH_EMAIL_LABEL,
  YOO_KASSA_PAYMENT_WITH_EMAIL_PATH,
  DETACH_RESPONSIBLE_FROM_LEAD_KEY,
  DETACH_RESPONSIBLE_FROM_LEAD_LABEL,
  DETACH_RESPONSIBLE_FROM_LEAD,
  DETACH_RESPONSIBLE_FROM_LEAD_PATH,
  ORGANIZATION_ANALYTICS_LABEL,
  ORGANIZATION_ANALYTICS,
  MEDICAL_CARD_REGISTRY_LABEL,
  MEDICAL_CARD_REGISTRY,
  MEDICAL_CARD_REGISTRY_PATH,
  MEDICAL_CARD_REGISTRY_KEY,
  ORGANIZATION_ANALYTICS_PATH,
  ORGANIZATION_ANALYTICS_KEY,
  DOCUMENT_TEMPLATES,
  DOCUMENT_TEMPLATES_KEY,
  DOCUMENT_TEMPLATES_LABEL,
  DOCUMENT_TEMPLATES_PATH,
  SALES_FUNNELS,
} from '@app/constants';
import { CalendarProvider as CalendarPageProvider } from '@app/pages/Calendar/context';
import { NewClientsListProvider } from '@app/pages/Clients/NewClientsList/context/NewClientsListProvider';
import { ServicesSortingLazy } from '@app/pages/Clients/ServicesSorting/__lazy';
import { EditEmployeePageHeader } from '@app/pages/Employees/EditEmployee/EditEmployeePageHeader';
import { IndividualCalendarProvider } from '@app/pages/IndividualCalendar/context';
import { MessageTemplatesHeader } from '@app/pages/Messages/MessageTemplatesRegistry/components/MessageTemplatesRegistryHeader';
import { OrganizationUsers } from '@app/pages/Organizations/OrganizationUsers/OrganizationUsers.main';
import { EditSendouts } from '@app/pages/Sendouts/EditSendouts';
import {
  CalendarModalProvider,
  CalendarProvider,
  ClientFiltersProvider,
  ClientPaymentsProvider,
  EditSalesFunnelProvider,
  FileProvider,
  HeaderProvider,
  IntegrationsProvider,
  RecordModalProvider,
  SearchIdProvider,
  TabsNotificationProvider,
} from '@app/providers';
import { SendoutsProvider } from '@app/providers/SendoutsProvider';
import {
  duplicateClientsPages,
  warehousesPages,
  clientsPages,
  leadsPages,
  mcpPages,
} from '@app/routes';
import {
  bookingPage,
  loyaltyPages,
  billingPage,
} from '@app/routes/iframe-routes';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import type { NNavigation } from '@app/types';

import { BranchesPageHeader } from '@pages/Branches/BranchesList/components';
import { Certificates, CertificatesPageHeader } from '@pages/Certificates';
import { ChainsPageHeader } from '@pages/Chains/ChainsList/components';
import { ClientFieldsPageHeader } from '@pages/ClientFields';
import {
  ClientPaymentsHeader,
  ClientPaymentsList,
  ClientsExport,
  ClientsListHeader,
  DetachResponsibleFromLead,
  EditClient,
  ImportFromExcel,
} from '@pages/Clients';
import { AddEmployeePageHeader } from '@pages/Employees/AddEmployee/components';
import { EmployeesPageHeader } from '@pages/Employees/EmployeesList';
import { PositionsPageHeader } from '@pages/Employees/Positions';
import {
  AddLegalEntities,
  LegalEntitiesPageHeader,
} from '@pages/LegalEntities';
import {
  OrganizationAnalytics,
  OrganizationAiSettings,
  Organizations,
  OrganizationSettings,
  OrganizationsPageHeader,
} from '@pages/Organizations';
import { Registration } from '@pages/Registration';
import { SalePlansHeader } from '@pages/SalePlans/components';
import {
  SendoutReceivers,
  Sendouts,
  SendoutsPageHeader,
} from '@pages/Sendouts';
import { ViewSendouts } from '@pages/Sendouts/ViewSendouts/ViewSendouts.main';
import { Subscriptions, SubscriptionsPageHeader } from '@pages/Subscriptions';
import { TagsPageHeader } from '@pages/Tags/components';
import { PageHeader } from '@pages/Users/UsersList';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

const settingsLevel: NPage.LevelDataModel = {
  title: generateSpanWithDataTestId(SETTINGS_LABEL, 'settings-page'),
  path: SETTINGS_PATH,
};

export const navigation: NNavigation.Main = [
  {
    id: ERROR_404,
    label: ERROR_404_LABEL,
    path: '*',
    element: <Error404NotFound />,
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    id: HEALTH_CHECK,
    label: 'Health Check',
    path: '/health-check',
    element: <HealthCheck />,
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    id: AUTHORIZATION,
    label: 'Вход в систему',
    path: AUTHORIZATION_PATH,
    element: (
      <LayoutLogin>
        <Authorization />
      </LayoutLogin>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    id: REGISTRATION,
    label: 'Регистрация',
    path: REGISTRATION_PATH,
    element: (
      <LayoutLogin>
        <Registration />
      </LayoutLogin>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: '15',
    icon: <></>,
    label: '',
    id: 'homePage',
    path: HOME_PAGE_PATH,
    element: <Page />,
    servicerightsid: undefined,
    issidebaritem: 'false',
    sidebarparentid: '',
  },
  {
    key: CALENDAR_KEY,
    icon: <CalendarOutlined />,
    label: RECORDS_JOURNAL_LABEL,
    [DATA_TESTID_ATTRIBUTE]: CALENDAR,
    id: CALENDAR,
    path: CALENDAR_PATH,
    title: NO_TOOLTIP_TITLE,
    element: (
      <CalendarPageProvider>
        <CalendarModalProvider>
          <RecordModalProvider>
            <Page disableBreadcrumbs headerContent={<CalendarHeader />}>
              <CalendarPage />
            </Page>
            <RecordModal />
          </RecordModalProvider>
        </CalendarModalProvider>
      </CalendarPageProvider>
    ),
    servicerightsid: RIGHTS_RECORDS,
    issidebaritem: 'true',
    sidebarparentid: CALENDAR,
  },
  {
    key: INDIVIDUAL_CALENDAR_KEY,
    icon: <CalendarOutlined />,
    label: 'Индивидуальный журнал записей',
    [DATA_TESTID_ATTRIBUTE]: INDIVIDUAL_CALENDAR,
    id: INDIVIDUAL_CALENDAR,
    path: INDIVIDUAL_CALENDAR_PATH,
    element: (
      <IndividualCalendarProvider>
        <RecordModalProvider>
          <Page disableBreadcrumbs headerContent={<IndividualCalendarHeader />}>
            <IndividualCalendarPage />
          </Page>
          <RecordModal />
        </RecordModalProvider>
      </IndividualCalendarProvider>
    ),
    servicerightsid: RIGHTS_RECORDS,
    issidebaritem: 'false',
    sidebarparentid: CALENDAR,
  },
  {
    key: RECORDS_KEY,
    icon: <BookOutlined />,
    label: RECORDS_LABEL,
    [DATA_TESTID_ATTRIBUTE]: RECORDS,
    pagebreadcrumbdatatestid: 'records-page',
    pagetitledatatestid: 'records-title',
    id: RECORDS,
    path: RECORDS_PATH,
    title: NO_TOOLTIP_TITLE,
    element: (
      <HeaderProvider>
        <RecordModalProvider>
          <CalendarProvider>
            <Page
              headerContent={<RecordsPageHeader />}
              contentLayoutClassName="records-list-content-layout"
            >
              <Records />
            </Page>
            <RecordModal />
          </CalendarProvider>
        </RecordModalProvider>
      </HeaderProvider>
    ),
    issidebaritem: 'true',
    servicerightsid: RIGHTS_RECORDS,
    sidebarparentid: RECORDS,
  },
  ...leadsPages,
  // Раздел «Задачи» идёт сразу после «Лиды» (task/11122): порядок этого
  // массива и есть порядок разделов в боковом меню.
  {
    key: TASK_LIST_KEY,
    icon: <SnippetsOutlined />,
    label: TASK_LIST_LABEL,
    [DATA_TESTID_ATTRIBUTE]: TASK_LIST,
    id: TASK_LIST,
    path: TASK_LIST_PATH,
    relativepath: `${TASK_LIST_PATH}?tab=registry`,
    title: NO_TOOLTIP_TITLE,
    element: (
      <HeaderProvider>
        <Page disableBreadcrumbs headerContent={<TaskListPageHeader />}>
          <TaskListPage />
        </Page>
      </HeaderProvider>
    ),
    issidebaritem: 'true',
    servicerightsid: RIGHTS_CRM_TASKS,
    sidebarparentid: TASK_LIST,
  },
  {
    key: CLIENTS_KEY,
    icon: <TeamOutlined />,
    label: CLIENTS_LABEL,
    [DATA_TESTID_ATTRIBUTE]: CLIENTS,
    pagebreadcrumbdatatestid: 'clients-page',
    pagetitledatatestid: 'clients-title',
    id: CLIENTS,
    path: CLIENTS_PATH,
    title: NO_TOOLTIP_TITLE,
    element: (
      <NewClientsListProvider>
        <FileProvider>
          <SearchIdProvider>
            <CalendarProvider>
              <RecordModalProvider>
                <ClientFiltersProvider>
                  <Page headerContent={<ClientsListHeader />}>
                    <ClientsList />
                  </Page>
                  <RecordModal />
                </ClientFiltersProvider>
              </RecordModalProvider>
            </CalendarProvider>
          </SearchIdProvider>
        </FileProvider>
      </NewClientsListProvider>
    ),
    servicerightsid: RIGHTS_CLIENTS,
    issidebaritem: 'true',
    sidebarparentid: CLIENTS,
  },
  {
    key: ANALYTICS_KEY,
    label: ANALYTICS_LABEL,
    icon: <BarChartOutlined />,
    [DATA_TESTID_ATTRIBUTE]: ANALYTICS,
    id: ANALYTICS,
    path: ANALYTICS_PATH,
    title: NO_TOOLTIP_TITLE,
    element: (
      <ClientPaymentsProvider>
        <HeaderProvider>
          <Page headerContent={<Analytics.Header />}>
            <Analytics.Page />
          </Page>
        </HeaderProvider>
      </ClientPaymentsProvider>
    ),
    issidebaritem: 'true',
    sidebarparentid: ANALYTICS,
    servicerightsid: RIGHTS_ANALYTICS,
  },
  {
    key: CLIENT_PAYMENTS_KEY,
    label: FINANCES_LABEL,
    [DATA_TESTID_ATTRIBUTE]: 'finances',
    pagebreadcrumbdatatestid: 'finance-page',
    pagetitledatatestid: 'finance-title',
    icon: <CrownOutlined />,
    id: CLIENT_PAYMENTS,
    path: CLIENT_PAYMENTS_PATH,
    title: NO_TOOLTIP_TITLE,
    element: (
      <FileProvider>
        <ClientPaymentsProvider>
          <Page headerContent={<ClientPaymentsHeader />}>
            <ClientPaymentsList />
          </Page>
        </ClientPaymentsProvider>
      </FileProvider>
    ),
    issidebaritem: 'true',
    sidebarparentid: CLIENT_PAYMENTS,
    servicerightsid: RIGHTS_SALES_REGISTER,
  },
  {
    key: EMPLOYEES_KEY,
    icon: <UsergroupAddOutlined />,
    label: EMPLOYEES_LABEL,
    [DATA_TESTID_ATTRIBUTE]: EMPLOYEES,
    id: EMPLOYEES,
    path: EMPLOYEES_PATH,
    title: NO_TOOLTIP_TITLE,
    pagebreadcrumbdatatestid: 'employees-page',
    pagetitledatatestid: 'employees-title',
    element: (
      <FileProvider>
        <HeaderProvider>
          <Page
            secondLevelData={{
              title: generateSpanWithDataTestId(
                SETTINGS_LABEL,
                'settings-page'
              ),
              path: SETTINGS_PATH,
            }}
            headerContent={<EmployeesPageHeader />}
          >
            <EmployeesList />
          </Page>
        </HeaderProvider>
      </FileProvider>
    ),
    issidebaritem: 'true',
    sidebarparentid: EMPLOYEES,
    servicerightsid: RIGHTS_USERS,
  },
  {
    key: SCHEDULE_KEY,
    icon: <ScheduleOutlined />,
    label: WORK_SCHEDULES_LABEL,
    [DATA_TESTID_ATTRIBUTE]: SCHEDULE,
    pagebreadcrumbdatatestid: 'work-schedule-page',
    pagetitledatatestid: 'work-schedule-title',
    id: SCHEDULE,
    path: SCHEDULE_PATH,
    element: (
      <HeaderProvider>
        <Page
          secondLevelData={settingsLevel}
          contentLayoutClassName="work-schedule-content-layout"
        >
          <WorkSchedule />
        </Page>
      </HeaderProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
    servicerightsid: RIGHTS_WORK_SCHEDULES,
  },
  {
    key: SETTINGS_KEY,
    label: SETTINGS_LABEL,
    pagebreadcrumbdatatestid: 'settings-page',
    pagetitledatatestid: 'settings-title',
    [DATA_TESTID_ATTRIBUTE]: SETTINGS,
    id: SETTINGS,
    path: SETTINGS_PATH,
    title: NO_TOOLTIP_TITLE,
    icon: <SettingOutlined />,
    element: (
      <Page>
        <Settings />
      </Page>
    ),
    issidebaritem: 'true',
    sidebarparentid: SETTINGS,
  },
  {
    key: CONTROL_PANEL_KEY,
    label: CONTROL_PANEL_LABEL,
    [DATA_TESTID_ATTRIBUTE]: CONTROL_PANEL,
    id: CONTROL_PANEL,
    pagebreadcrumbdatatestid: 'control-panel-page',
    pagetitledatatestid: 'control-panel-title',
    path: CONTROL_PANEL_PATH,
    title: NO_TOOLTIP_TITLE,
    icon: <ControlOutlined />,
    element: (
      <Page>
        <ControlPanel />
      </Page>
    ),
    issidebaritem: 'true',
    sidebarparentid: CONTROL_PANEL,
  },
  {
    key: CHAINS_KEY,
    icon: <BranchesOutlined />,
    label: CHAINS_LABEL,
    pagebreadcrumbdatatestid: 'chains-page',
    pagetitledatatestid: 'chains-title',
    id: CHAINS_ID,
    path: CHAINS_PATH,
    element: (
      <Page
        headerContent={<ChainsPageHeader />}
        secondLevelData={settingsLevel}
      >
        <ChainsList />
      </Page>
    ),
    servicerightsid: RIGHTS_CHAINS,
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: ADD_CHAIN_KEY,
    id: ADD_CHAIN,
    label: ADD_CHAIN_LABEL,
    path: `${CHAINS_PATH}/add/`,
    pagebreadcrumbdatatestid: 'add-chain-page',
    pagetitledatatestid: 'add-chain-title',
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(CHAINS_LABEL, 'chains-page'),
          path: CHAINS_PATH,
        }}
      >
        <AddChain />
      </Page>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_CHAINS,
    sidebarparentid: SETTINGS,
  },
  {
    key: '17',
    id: EDIT_CHAIN,
    label: EDIT_CHAIN_LABEL,
    path: `${CHAINS_PATH}/edit/`,
    pagebreadcrumbdatatestid: 'edit-chain-page',
    pagetitledatatestid: 'edit-chain-title',
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(CHAINS_LABEL, 'chains-page'),
          path: CHAINS_PATH,
        }}
      >
        <AddChain />
      </Page>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_CHAINS,
    sidebarparentid: SETTINGS,
  },
  {
    key: USERS_KEY,
    icon: <ContactsOutlined />,
    label: USERS_LABEL,
    id: USERS,
    path: USERS_PATH,
    pagebreadcrumbdatatestid: 'users-page',
    pagetitledatatestid: 'users-title',
    element: (
      <Page secondLevelData={settingsLevel} headerContent={<PageHeader />}>
        <UsersList />
      </Page>
    ),
    servicerightsid: RIGHTS_USERS,
    issidebaritem: 'false',
    sidebarparentid: USERS,
  },
  {
    key: ADD_USER_KEY,
    label: ADD_USER_LABEL,
    id: ADD_USER_ID,
    path: `${USERS_PATH}/add`,
    pagebreadcrumbdatatestid: 'add-user-page',
    pagetitledatatestid: 'add-user',
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(USERS_LABEL, 'users-page'),
          path: USERS_PATH,
        }}
      >
        <AddUser />
      </Page>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_USERS,
    sidebarparentid: USERS,
  },
  {
    key: ADD_BRANCH_KEY,
    id: ADD_BRANCH,
    label: ADD_BRANCH_LABEL,
    pagebreadcrumbdatatestid: 'add-branch-page',
    pagetitledatatestid: 'add-branch-title',
    path: `/${BRANCHES}/add`,
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(BRANCHES_LABEL, 'branches-page'),
          path: BRANCHES_PATH,
        }}
      >
        <AddBranch />
      </Page>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_BRANCHES,
    sidebarparentid: SETTINGS,
  },
  {
    key: EDIT_BRANCH_KEY,
    id: EDIT_BRANCH,
    label: EDIT_BRANCH_LABEL,
    path: `/${BRANCHES}/edit/`,
    pagebreadcrumbdatatestid: 'edit-branch-page',
    pagetitledatatestid: 'edit-branch-title',
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(BRANCHES_LABEL, 'branches-page'),
          path: BRANCHES_PATH,
        }}
      >
        <AddBranch />
      </Page>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_BRANCHES,
    sidebarparentid: SETTINGS,
  },
  {
    key: BRANCHES_PREVIEW_KEY,
    label: BRANCHES_PREVIEW_LABEL,
    pagebreadcrumbdatatestid: 'branches-preview-page',
    pagetitledatatestid: 'branches-preview-title',
    id: BRANCHES_PREVIEW,
    path: BRANCHES_PREVIEW_PATH,
    element: (
      <Page
        headerContent={<BranchesPageHeader />}
        secondLevelData={{
          title: SETTINGS_LABEL,
          path: SETTINGS_PATH,
        }}
        thirdLevelData={{
          title: CHAINS_LABEL,
          path: CHAINS_PATH,
        }}
      >
        <BranchesList />
      </Page>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_CHAINS,
    sidebarparentid: SETTINGS,
  },
  {
    key: EDIT_USER_KEY,
    id: EDIT_USER,
    label: EDIT_USER_LABEL,
    path: `${USERS_PATH}/edit/`,
    pagebreadcrumbdatatestid: 'edit-user-page',
    pagetitledatatestid: 'user-name',
    element: (
      <Page
        secondLevelData={{
          title: generateSpanWithDataTestId(SETTINGS_LABEL, 'settings-page'),
          path: SETTINGS_PATH,
        }}
        thirdLevelData={{
          title: generateSpanWithDataTestId(USERS_LABEL, 'users-page'),
          path: USERS_PATH,
        }}
      >
        <EditUser />
      </Page>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_USERS,
    sidebarparentid: USERS,
  },
  {
    key: PROFILE_KEY,
    icon: <UserOutlined />,
    label: PROFILE_LABEL,
    id: USER_PROFILE,
    path: PROFILE_PATH,
    pagebreadcrumbdatatestid: 'personal-account-page',
    pagetitledatatestid: 'personal-cabinet-title',
    element: (
      <Page secondLevelData={settingsLevel}>
        <UserProfile />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: ADD_CLIENT_KEY,
    label: ADD_CLIENT_LABEL,
    id: ADD_CLIENT,
    path: `${CLIENTS_PATH}/add`,
    element: (
      <Page
        secondLevelData={{
          title: CLIENTS_LABEL,
          path: CLIENTS_PATH,
        }}
      >
        <AddClient />
      </Page>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_CLIENTS,
    sidebarparentid: CLIENTS,
  },
  {
    key: EDIT_CLIENT_KEY,
    label: EDIT_CLIENT_LABEL,
    id: EDIT_CLIENT,
    path: EDIT_CLIENT_PATH,
    element: (
      <RecordModalProvider>
        <ClientFiltersProvider>
          <Page
            secondLevelData={{
              title: CLIENTS_LABEL,
              path: CLIENTS_PATH,
            }}
          >
            <EditClient />
          </Page>
          <RecordModal />
        </ClientFiltersProvider>
      </RecordModalProvider>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_CLIENTS,
    sidebarparentid: CLIENTS,
  },
  {
    key: CLIENT_CARD_KEY,
    label: CLIENT_CARD_LABEL,
    id: CLIENT_CARD,
    path: CLIENT_CARD_PATH,
    element: (
      <HeaderProvider>
        <CalendarProvider>
          <RecordModalProvider>
            <ClientFiltersProvider>
              <Page
                secondLevelData={{
                  title: CLIENTS_LABEL,
                  path: CLIENTS_PATH,
                }}
                contentLayoutClassName="client-card-content-layout"
              >
                <ClientLeadCardPage />
              </Page>
              <RecordModal />
            </ClientFiltersProvider>
          </RecordModalProvider>
        </CalendarProvider>
      </HeaderProvider>
    ),
    issidebaritem: 'false',
    servicerightsid: RIGHTS_CLIENTS,
    sidebarparentid: CLIENTS,
  },
  {
    key: TAGS_KEY,
    icon: <TagsOutlined />,
    label: TAGS_LABEL,
    id: TAGS,
    pagebreadcrumbdatatestid: 'tags-page',
    pagetitledatatestid: 'tags-title',
    path: TAGS_PATH,
    element: (
      <HeaderProvider>
        <Page
          headerContent={<TagsPageHeader />}
          secondLevelData={{
            title: generateSpanWithDataTestId(SETTINGS_LABEL, 'settings-page'),
            path: SETTINGS_PATH,
          }}
        >
          <Tags />
        </Page>
      </HeaderProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: CLIENT_FIELDS_KEY,
    icon: <TagsOutlined />,
    label: CLIENT_FIELDS_LABEL,
    id: CLIENT_FIELDS,
    pagebreadcrumbdatatestid: 'client-fields-page',
    pagetitledatatestid: 'client-fields-title',
    path: CLIENT_FIELDS_PATH,
    element: (
      <HeaderProvider>
        <Page
          headerContent={<ClientFieldsPageHeader />}
          secondLevelData={{
            title: generateSpanWithDataTestId(SETTINGS_LABEL, 'settings-page'),
            path: SETTINGS_PATH,
          }}
        >
          <ClientFields />
        </Page>
      </HeaderProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: SUBSCRIPTIONS_KEY,
    icon: <TagsOutlined />,
    label: SUBSCRIPTIONS_LABEL,
    id: SUBSCRIPTIONS,
    pagebreadcrumbdatatestid: 'subscriptions-page',
    pagetitledatatestid: 'subscriptions-title',
    path: SUBSCRIPTIONS_PATH,
    element: (
      <HeaderProvider>
        <Page
          headerContent={<SubscriptionsPageHeader />}
          secondLevelData={{
            title: generateSpanWithDataTestId(SETTINGS_LABEL, 'settings-page'),
            path: SETTINGS_PATH,
          }}
        >
          <Subscriptions />
        </Page>
      </HeaderProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: CERTIFICATES_KEY,
    icon: <GiftOutlined />,
    label: CERTIFICATES_LABEL,
    id: CERTIFICATES,
    pagebreadcrumbdatatestid: 'certificates-page',
    pagetitledatatestid: 'certificates-title',
    path: CERTIFICATES_PATH,
    element: (
      <HeaderProvider>
        <Page
          headerContent={<CertificatesPageHeader />}
          secondLevelData={{
            title: generateSpanWithDataTestId(SETTINGS_LABEL, 'settings-page'),
            path: SETTINGS_PATH,
          }}
        >
          <Certificates />
        </Page>
      </HeaderProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: ADD_EMPLOYEE_KEY,
    label: ADD_EMPLOYEES_LABEL,
    id: ADD_EMPLOYEE,
    path: `${EMPLOYEES_PATH}/add/`,
    pagebreadcrumbdatatestid: 'add-employee-page',
    pagetitledatatestid: 'add-employee',
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(EMPLOYEES_LABEL, 'employees-page'),
          path: EMPLOYEES_PATH,
        }}
      >
        <AddEmployee />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: EMPLOYEES,
  },
  {
    key: POSITIONS_KEY,
    icon: <FormatPainterOutlined />,
    label: POSITIONS_LABEL,
    pagebreadcrumbdatatestid: 'positions-page',
    pagetitledatatestid: 'positions-title',
    id: POSITIONS,
    path: POSITIONS_PATH,
    element: (
      <Page
        headerContent={<PositionsPageHeader />}
        secondLevelData={settingsLevel}
      >
        <Positions />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: ADD_POSITION_KEY,
    label: ADD_POSITION_LABEL,
    pagebreadcrumbdatatestid: 'add-position-page',
    pagetitledatatestid: 'add-position',
    id: ADD_POSITION,
    path: ADD_POSITION_PATH,
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(POSITIONS_LABEL, 'positions-page'),
          path: POSITIONS_PATH,
        }}
        headerContent={<AddEmployeePageHeader />}
      >
        <AddPosition />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: EDIT_POSITION_KEY,
    label: EDIT_POSITION_LABEL,
    pagebreadcrumbdatatestid: 'edit-position-page',
    pagetitledatatestid: 'edit-position-title',
    id: EDIT_POSITION,
    path: EDIT_POSITION_PATH,
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(POSITIONS_LABEL, 'positions-page'),
          path: POSITIONS_PATH,
        }}
      >
        <AddPosition />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    label: EMAIL_VERIFICATION_LABEL,
    id: EMAIL_VERIFICATION,
    path: EMAIL_VERIFICATION_PATH,
    element: <EmailChange />,
    issidebaritem: 'false',
    sidebarparentid: PROFILE,
  },
  {
    key: CLIENT_SERVICES_KEY,
    label: CLIENT_SERVICES_LABEL,
    id: CLIENT_SERVICES,
    path: CLIENT_SERVICES_PATH,
    pagebreadcrumbdatatestid: 'services-page',
    pagetitledatatestid: 'services-title',
    icon: <ProfileOutlined />,
    element: (
      <FileProvider>
        <HeaderProvider>
          <Page
            headerContent={<ServicesSortingHeader />}
            secondLevelData={{
              title: generateSpanWithDataTestId(
                SETTINGS_LABEL,
                'settings-page'
              ),
              path: SETTINGS_PATH,
            }}
          >
            <ServicesSortingLazy />
          </Page>
        </HeaderProvider>
      </FileProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: EDIT_EMPLOYEE_KEY,
    label: EDIT_EMPLOYEE_LABEL,
    id: EDIT_EMPLOYEE,
    path: EDIT_EMPLOYEE_PATH,
    pagebreadcrumbdatatestid: 'edit-employee-page',
    pagetitledatatestid: 'name-employee',
    element: (
      <TabsNotificationProvider>
        <Page
          secondLevelData={{
            title: generateSpanWithDataTestId(SETTINGS_LABEL, 'settings-page'),
            path: SETTINGS_PATH,
          }}
          thirdLevelData={{
            title: generateSpanWithDataTestId(
              EMPLOYEES_LABEL,
              'employees-page'
            ),
            path: EMPLOYEES_PATH,
          }}
          headerContent={<EditEmployeePageHeader />}
        >
          <EditEmployee />
        </Page>
      </TabsNotificationProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: EMPLOYEES,
  },
  {
    key: CATEGORIES_KEY,
    label: CATEGORIES_LABEL,
    id: CATEGORIES,
    icon: <GroupOutlined />,
    path: CATEGORIES_PATH,
    pagebreadcrumbdatatestid: 'services-categories-page',
    pagetitledatatestid: 'services-categories-title',
    element: (
      <Page
        headerContent={<ServiceCategories.Header />}
        secondLevelData={settingsLevel}
      >
        <ServiceCategories.Page />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: ADD_CATEGORY_KEY,
    label: ADD_CATEGORY_LABEL,
    id: ADD_CATEGORY,
    path: ADD_CATEGORY_PATH,
    pagebreadcrumbdatatestid: 'create-category-page',
    pagetitledatatestid: 'create-category-title',
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(
            CATEGORIES_LABEL,
            'services-categories-page'
          ),
          path: CATEGORIES_PATH,
        }}
      >
        <AddServiceCategory />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: EDIT_CATEGORY_KEY,
    label: EDIT_CATEGORY_LABEL,
    id: EDIT_SERVICE_CATEGORY,
    path: EDIT_CATEGORY_PATH,
    pagebreadcrumbdatatestid: 'edit-category-page',
    pagetitledatatestid: 'edit-category-title',
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(
            CATEGORIES_LABEL,
            'services-categories-page'
          ),
          path: CATEGORIES_PATH,
        }}
      >
        <AddServiceCategory />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: ADD_SERVICE_KEY,
    label: ADD_CLIENT_SERVICES_LABEL,
    id: ADD_SERVICE,
    path: ADD_SERVICE_PATH,
    pagebreadcrumbdatatestid: 'add-service-page',
    pagetitledatatestid: 'add-service-title',
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(
            CLIENT_SERVICES_LABEL,
            'services-page'
          ),
          path: CLIENT_SERVICES_PATH,
        }}
      >
        <EditClientService />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: EDIT_SERVICE_KEY,
    label: EDIT_CLIENT_SERVICES_LABEL,
    id: EDIT_CLIENT_SERVICES,
    path: EDIT_SERVICE_PATH,
    pagebreadcrumbdatatestid: 'edit-service-page',
    pagetitledatatestid: 'edit-service-title',
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(
            CLIENT_SERVICES_LABEL,
            'services-page'
          ),
          path: CLIENT_SERVICES_PATH,
        }}
      >
        <EditClientService />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: IMPORT_SERVICES_KEY,
    label: IMPORT_SERVICES_LABEL,
    id: IMPORT_SERVICES,
    path: IMPORT_SERVICES_PATH,
    pagebreadcrumbdatatestid: 'import-services-page',
    pagetitledatatestid: 'import-services-title',
    element: (
      <FileProvider>
        <Page
          secondLevelData={{
            title: generateSpanWithDataTestId(SETTINGS_LABEL, 'settings-page'),
            path: SETTINGS_PATH,
          }}
          thirdLevelData={{
            title: generateSpanWithDataTestId(
              CLIENT_SERVICES_LABEL,
              'services-page'
            ),
            path: CLIENT_SERVICES_PATH,
          }}
        >
          <ImportFromExcel />
        </Page>
      </FileProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: IMPORT_EMPLOYEES_KEY,
    label: IMPORT_EMPLOYEES_LABEL,
    id: IMPORT_EMPLOYEES,
    path: IMPORT_EMPLOYEES_PATH,
    pagebreadcrumbdatatestid: 'import-executors-page',
    pagetitledatatestid: 'import-executors-title',
    element: (
      <FileProvider>
        <Page
          secondLevelData={{
            title: SETTINGS_LABEL,
            path: SETTINGS_PATH,
          }}
          thirdLevelData={{
            title: EMPLOYEES_LABEL,
            path: EMPLOYEES_PATH,
          }}
        >
          <ImportFromExcel />
        </Page>
      </FileProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: EMPLOYEES,
  },
  {
    key: IMPORT_CLIENTS_KEY,
    label: IMPORT_CLIENTS_LABEL,
    id: IMPORT_CLIENTS,
    path: IMPORT_CLIENTS_PATH,
    element: (
      <FileProvider>
        <Page
          secondLevelData={{
            title: CLIENTS_LABEL,
            path: CLIENTS_PATH,
          }}
        >
          <ImportFromExcel />
        </Page>
      </FileProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: IMPORT_RECORDS_KEY,
    label: IMPORT_RECORDS_LABEL,
    id: IMPORT_RECORDS,
    path: IMPORT_RECORDS_PATH,
    element: (
      <FileProvider>
        <Page
          secondLevelData={{
            title: RECORDS_LABEL,
            path: RECORDS_PATH,
          }}
        >
          <ImportFromExcel />
        </Page>
      </FileProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: RECORDS,
  },
  {
    key: LEGAL_ENTITIES_KEY,
    label: LEGAL_ENTITIES_LABEL,
    id: LEGAL_ENTITIES_ID,
    path: LEGAL_ENTITIES_PATH,
    pagebreadcrumbdatatestid: 'legal-entities-page',
    pagetitledatatestid: 'legal-entities-title',
    icon: <BankOutlined />,
    element: (
      <Page
        headerContent={<LegalEntitiesPageHeader />}
        secondLevelData={settingsLevel}
      >
        <LegalEntities />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: ADD_LEGAL_ENTITY_KEY,
    label: ADD_LEGAL_ENTITY_LABEL,
    id: ADD_LEGAL_ENTITY,
    path: ADD_LEGAL_ENTITY_PATH,
    pagebreadcrumbdatatestid: 'add-legal-entity-page',
    pagetitledatatestid: 'add-legal-entity-title',
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(
            LEGAL_ENTITIES_LABEL,
            'legal-entities-page'
          ),
          path: LEGAL_ENTITIES_PATH,
        }}
      >
        <AddLegalEntities />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: PAYMENTS_ACCOUNTS_KEY,
    label: PAYMENTS_ACCOUNTS_LABEL,
    pagebreadcrumbdatatestid: 'payment-accounts-page',
    pagetitledatatestid: 'payment-accounts',
    id: PAYMENTS_ACCOUNTS,
    path: PAYMENTS_ACCOUNTS_PATH,
    icon: <MoneyCollectOutlined />,
    element: (
      <Page
        headerContent={<PaymentAccountsPageHeader />}
        secondLevelData={settingsLevel}
      >
        <PaymentAccounts />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: ADD_PAYMENT_ACCOUNT_KEY,
    label: ADD_PAYMENT_ACCOUNT_LABEL,
    pagebreadcrumbdatatestid: 'add-payment-account-page',
    pagetitledatatestid: 'add-payment-account',
    id: ADD_PAYMENT_ACCOUNT,
    path: ADD_PAYMENT_ACCOUNT_PATH,
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(
            PAYMENTS_ACCOUNTS_LABEL,
            'payment-accounts-page'
          ),
          path: PAYMENTS_ACCOUNTS_PATH,
        }}
      >
        <AddPaymentsAccount />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: EDIT_PAYMENT_ACCOUNT_KEY,
    label: EDIT_PAYMENT_ACCOUNT_LABEL,
    pagebreadcrumbdatatestid: 'edit-payment-accounts-page',
    pagetitledatatestid: 'edit-payment-accounts',
    id: EDIT_PAYMENT_ACCOUNT,
    path: EDIT_PAYMENT_ACCOUNT_PATH,
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(
            PAYMENTS_ACCOUNTS_LABEL,
            'payment-accounts-page'
          ),
          path: PAYMENTS_ACCOUNTS_PATH,
        }}
      >
        <AddPaymentsAccount />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: INTEGRATIONS_KEY,
    label: INTEGRATIONS_LABEL,
    id: INTEGRATIONS,
    path: INTEGRATIONS_PATH,
    pagebreadcrumbdatatestid: 'integrations-page',
    pagetitledatatestid: 'integrations-title',
    icon: <ClusterOutlined />,
    element: (
      <IntegrationsProvider>
        <Page
          headerContent={<IntegrationsPageHeader />}
          secondLevelData={settingsLevel}
        >
          <Integrations />
        </Page>
      </IntegrationsProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: MCP_INTEGRATION,
    label: MCP_INTEGRATION_LABEL,
    id: MCP_INTEGRATION,
    path: MCP_INTEGRATION_PATH,
    pagebreadcrumbdatatestid: 'mcp-integration-page',
    pagetitledatatestid: 'mcp-integration-title',
    icon: <ClusterOutlined />,
    element: (
      <Page secondLevelData={settingsLevel}>
        <McpIntegration />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: PROXY,
    label: PROXY_LABEL,
    id: PROXY,
    path: PROXY_ROUTE_PATH,
    pagebreadcrumbdatatestid: 'proxy-page',
    pagetitledatatestid: 'proxy-title',
    icon: <ClusterOutlined />,
    element: (
      <Page secondLevelData={settingsLevel}>
        <ProxyIntegration />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  ...mcpPages,
  {
    key: SALE_PLANS_KEY,
    label: SALE_PLANS_LABEL,
    id: SALE_PLANS_ID,
    pagebreadcrumbdatatestid: 'sales-plans-page',
    pagetitledatatestid: 'sales-plans-title',
    path: SALE_PLANS_PATH,
    element: (
      <HeaderProvider>
        <Page
          headerContent={<SalePlansHeader />}
          secondLevelData={{
            title: generateSpanWithDataTestId(SETTINGS_LABEL, 'settings-page'),
            path: SETTINGS_PATH,
          }}
        >
          <SalePlans />
        </Page>
      </HeaderProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: DATA_MIGRATION_KEY,
    label: DATA_MIGRATION_LABEL,
    id: DATA_MIGRATION,
    path: DATA_MIGRATION_PATH,
    pagebreadcrumbdatatestid: 'migration-data-page',
    pagetitledatatestid: 'migration-data-title',
    element: (
      <Page
        headerContent={<DataMigrationHeader />}
        secondLevelData={{
          title: generateSpanWithDataTestId(SETTINGS_LABEL, 'settings-page'),
          path: SETTINGS_PATH,
        }}
      >
        <DataMigration />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: MIGRATION_CARD_KEY,
    label: MIGRATION_CARD_LABEL,
    pagebreadcrumbdatatestid: 'migration-card-page',
    pagetitledatatestid: 'migration-card-title',
    id: MIGRATION_CARD,
    path: MIGRATION_CARD_PATH,
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(
            DATA_MIGRATION_LABEL,
            'migration-data-page'
          ),
          path: DATA_MIGRATION_PATH,
        }}
      >
        <DataMigrationViewer />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: OPERATIONS_KEY,
    label: OPERATIONS_LABEL,
    id: OPERATIONS,
    path: OPERATIONS_PATH,
    element: (
      <RecordModalProvider>
        <Page
          secondLevelData={{
            title: SETTINGS_LABEL,
            path: SETTINGS_PATH,
          }}
        >
          <FinancialOperations />
        </Page>
        <RecordModal />
      </RecordModalProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
    servicerightsid: RIGHTS_SALES_REGISTER,
  },
  {
    key: ACTIONS_HISTORY_KEY,
    label: ACTIONS_HISTORY_LABEL,
    id: ACTIONS_HISTORY,
    pagebreadcrumbdatatestid: 'actions-history-page',
    pagetitledatatestid: 'actions-history-title',
    path: ACTIONS_HISTORY_PATH,
    element: (
      <Page secondLevelData={settingsLevel}>
        <ActionsHistoryPage />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: FILE_EXPORT_KEY,
    id: FILE_EXPORT,
    label: FILE_EXPORT_LABEL,
    path: FILE_EXPORT_PATH,
    pagebreadcrumbdatatestid: 'export-file-page',
    pagetitledatatestid: 'export-file-page-title',
    element: (
      <Page secondLevelData={settingsLevel}>
        <ClientsExport />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: BRANCHES_KEY,
    label: BRANCHES_LABEL,
    pagebreadcrumbdatatestid: 'branches-page',
    pagetitledatatestid: 'branches-title',
    id: BRANCHES,
    path: BRANCHES_PATH,
    icon: <HomeOutlined />,
    element: (
      <Page
        headerContent={<BranchesPageHeader />}
        secondLevelData={settingsLevel}
      >
        <BranchesList />
      </Page>
    ),
    servicerightsid: RIGHTS_BRANCHES,
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: EDIT_LEGAL_ENTITY_KEY,
    label: EDIT_LEGAL_ENTITY_LABEL,
    id: EDIT_LEGAL_ENTITY,
    path: EDIT_LEGAL_ENTITY_PATH,
    pagebreadcrumbdatatestid: 'legal-entity-page',
    pagetitledatatestid: 'edit-legal-entity',
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(
            LEGAL_ENTITIES_LABEL,
            'legal-entities-page'
          ),
          path: LEGAL_ENTITIES_PATH,
        }}
      >
        <AddLegalEntities />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    icon: <MessageOutlined />,
    key: MESSAGES_KEY,
    label: MESSAGES_LABEL,
    id: MESSAGES,
    path: MESSAGES_PATH,
    element: (
      <Page
        secondLevelData={{
          title: CONTROL_PANEL_LABEL,
          path: CONTROL_PANEL_PATH,
        }}
      >
        <Messages />
      </Page>
    ),
    [DATA_TESTID_ATTRIBUTE]: MESSAGES,
    issidebaritem: 'false',
    sidebarparentid: MESSAGES,
  },
  {
    key: SORT_EMPLOYEES_KEY,
    label: SORT_EMPLOYEES_LABEL,
    id: SORT_EMPLOYEES,
    path: SORT_EMPLOYEES_PATH,
    pagebreadcrumbdatatestid: 'sort-employees-page',
    pagetitledatatestid: 'sort-employees-title',
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: EMPLOYEES_LABEL,
          path: EMPLOYEES_PATH,
        }}
      >
        <SortEmployees />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: EMPLOYEES,
  },
  {
    key: SALES_FUNNELS_KEY,
    label: SALES_FUNNELS_LABEL,
    [DATA_TESTID_ATTRIBUTE]: SALES_FUNNELS,
    id: SALES_FUNNELS,
    path: SALES_FUNNELS_PATH,
    title: NO_TOOLTIP_TITLE,
    icon: <FilterOutlined />,
    element: (
      <HeaderProvider>
        <Page headerContent={<SalesFunnelsPageHeader />}>
          <SalesFunnels />
        </Page>
      </HeaderProvider>
    ),
    issidebaritem: 'true',
    servicerightsid: RIGHTS_SALES_FUNNELS,
    sidebarparentid: SALES_FUNNELS,
  },
  {
    key: VIEW_SALES_FUNNEL_KEY,
    label: VIEW_SALES_FUNNEL_LABEL,
    id: VIEW_SALES_FUNNEL,
    path: VIEW_SALES_FUNNEL_PATH,
    element: (
      <Page disableBreadcrumbs headerContent={<ViewSalesFunnelPageHeader />}>
        <ViewSalesFunnel />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SALES_FUNNELS,
  },
  {
    key: EDIT_SALES_FUNNEL_KEY,
    label: EDIT_SALES_FUNNEL_LABEL,
    id: EDIT_SALES_FUNNEL,
    path: EDIT_SALES_FUNNEL_PATH,
    element: (
      <EditSalesFunnelProvider>
        <Page
          secondLevelData={{
            title: SALES_FUNNELS_LABEL,
            path: SALES_FUNNELS_PATH,
          }}
          headerContent={<EditSalesFunnelPageHeader />}
        >
          <EditSalesFunnel />
        </Page>
      </EditSalesFunnelProvider>
    ),
    issidebaritem: 'false',
    sidebarparentid: SALES_FUNNELS,
  },
  {
    key: ORGANIZATIONS_KEY,
    icon: (
      <FontAwesomeIcon
        icon={'fa-solid fa-bars' as IconProp}
        size="sm"
        className="location-icon"
      />
    ),
    pagebreadcrumbdatatestid: 'organizations-page',
    pagetitledatatestid: 'organizations-title',
    label: ORGANIZATIONS_LABEL,
    [DATA_TESTID_ATTRIBUTE]: ORGANIZATIONS,
    id: ORGANIZATIONS,
    path: ORGANIZATIONS_PATH,
    title: NO_TOOLTIP_TITLE,
    element: (
      <Page headerContent={<OrganizationsPageHeader />}>
        <Organizations />
      </Page>
    ),
    issidebaritem: 'true',
    sidebarparentid: ORGANIZATIONS,
  },
  {
    key: ORGANIZATION_SETTINGS_KEY,
    id: ORGANIZATION_SETTINGS,
    label: ORGANIZATION_SETTINGS_LABEL,
    path: `${ORGANIZATIONS_PATH}/settings/`,
    pagebreadcrumbdatatestid: 'organization-settings-page',
    pagetitledatatestid: 'organization-settings-title',
    element: (
      <Page
        secondLevelData={{
          title: generateSpanWithDataTestId(
            ORGANIZATIONS_LABEL,
            'organization-page'
          ),
          path: ORGANIZATIONS_PATH,
        }}
      >
        <OrganizationSettings />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: ORGANIZATIONS,
  },
  {
    key: ORGANIZATION_USERS_KEY,
    id: ORGANIZATION_USERS,
    label: ORGANIZATION_USERS_LABEL,
    path: `${ORGANIZATIONS_PATH}/users/`,
    pagebreadcrumbdatatestid: 'users-page',
    pagetitledatatestid: 'users-title',
    element: (
      <Page
        secondLevelData={{
          title: generateSpanWithDataTestId(
            ORGANIZATIONS_LABEL,
            'organization-page'
          ),
          path: ORGANIZATIONS_PATH,
        }}
      >
        <OrganizationUsers />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: ORGANIZATIONS,
  },
  {
    key: ORGANIZATION_AI_SETTINGS_KEY,
    id: ORGANIZATION_AI_SETTINGS,
    label: ORGANIZATION_AI_SETTINGS_LABEL,
    path: ORGANIZATION_AI_SETTINGS_PATH,
    pagebreadcrumbdatatestid: 'organization-ai-settings-page',
    pagetitledatatestid: 'organization-ai-settings-title',
    element: (
      <Page
        secondLevelData={{
          title: generateSpanWithDataTestId(
            ORGANIZATIONS_LABEL,
            'organization-page'
          ),
          path: ORGANIZATIONS_PATH,
        }}
      >
        <OrganizationAiSettings />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: ORGANIZATIONS,
  },
  {
    key: SENDOUTS_KEY,
    icon: <FontAwesomeIcon icon={'fa-solid fa-table' as IconProp} size="sm" />,
    label: SENDOUTS_LABEL,
    [DATA_TESTID_ATTRIBUTE]: SENDOUTS,
    id: SENDOUTS,
    path: SENDOUTS_PATH,
    title: NO_TOOLTIP_TITLE,
    pagebreadcrumbdatatestid: 'sendouts-page',
    pagetitledatatestid: 'sendouts-title',
    element: (
      <SendoutsProvider>
        <Page headerContent={<SendoutsPageHeader />}>
          <Sendouts />
        </Page>
      </SendoutsProvider>
    ),
    servicerightsid: RIGHTS_SENDOUTS,
    issidebaritem: 'true',
    sidebarparentid: SENDOUTS,
  },
  {
    key: EDIT_SENDOUTS_KEY,
    label: EDIT_SENDOUTS_LABEL,
    [DATA_TESTID_ATTRIBUTE]: EDIT_SENDOUTS,
    id: EDIT_SENDOUTS,
    path: `${EDIT_SENDOUTS_PATH}/:id`,
    title: NO_TOOLTIP_TITLE,
    element: (
      <Page
        secondLevelData={{
          title: generateSpanWithDataTestId(SENDOUTS_LABEL, 'sendouts-page'),
          path: SENDOUTS_PATH,
        }}
      >
        <EditSendouts />
      </Page>
    ),
    servicerightsid: RIGHTS_SENDOUTS,
    issidebaritem: 'false',
    sidebarparentid: SENDOUTS,
  },
  {
    key: VIEW_SENDOUTS_KEY,
    icon: <FontAwesomeIcon icon={'fa-solid fa-table' as IconProp} size="sm" />,
    label: VIEW_SENDOUTS_LABEL,
    id: VIEW_SENDOUTS,
    path: VIEW_SENDOUTS_PATH,
    pagebreadcrumbdatatestid: 'sendout-view-page',
    pagetitledatatestid: 'sendout-name-title',
    element: (
      <SendoutsProvider>
        <Page
          secondLevelData={{
            title: generateSpanWithDataTestId(SENDOUTS_LABEL, 'sendouts-page'),
            path: SENDOUTS_PATH,
          }}
        >
          <ViewSendouts />
        </Page>
      </SendoutsProvider>
    ),
    servicerightsid: RIGHTS_SENDOUTS,
    issidebaritem: 'false',
    sidebarparentid: SENDOUTS,
  },
  {
    key: SENDOUT_RECEIVERS_KEY,
    label: SENDOUT_RECEIVERS_LABEL,
    id: SENDOUT_RECEIVERS,
    path: SENDOUT_RECEIVERS_PATH,
    pagebreadcrumbdatatestid: 'recipients-sendout-page',
    pagetitledatatestid: 'recipients-sendout-title',
    element: (
      <Page
        secondLevelData={{
          title: generateSpanWithDataTestId(SENDOUTS_LABEL, 'sendouts-page'),
          path: SENDOUTS_PATH,
        }}
        thirdLevelData={{
          title: generateSpanWithDataTestId(
            VIEW_SENDOUTS_LABEL,
            'sendout-name-page'
          ),
          path: '',
        }}
      >
        <SendoutReceivers />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SENDOUTS,
  },
  {
    key: MESSAGE_TEMPLATES_KEY,
    label: MESSAGE_TEMPLATES_LABEL,
    pagebreadcrumbdatatestid: 'templates-messages-page',
    pagetitledatatestid: 'templates-messages-title',
    id: MESSAGE_TEMPLATES,
    path: MESSAGE_TEMPLATES_PATH,
    element: (
      <Page
        headerContent={<MessageTemplatesHeader />}
        secondLevelData={settingsLevel}
      >
        <MessageTemplatesRegistry />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: ADD_MESSAGE_TEMPLATE_KEY,
    label: ADD_MESSAGE_TEMPLATE_LABEL,
    id: ADD_MESSAGE_TEMPLATE,
    pagebreadcrumbdatatestid: 'add-template-page',
    pagetitledatatestid: 'add-template-title',
    path: ADD_MESSAGE_TEMPLATE_PATH,
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(
            MESSAGE_TEMPLATES_LABEL,
            'templates-messages-page'
          ),
          path: MESSAGE_TEMPLATES_PATH,
        }}
      >
        <ManageMessageTemplate />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: EDIT_MESSAGE_TEMPLATE_KEY,
    label: EDIT_MESSAGE_TEMPLATE_LABEL,
    id: EDIT_MESSAGE_TEMPLATE,
    pagebreadcrumbdatatestid: 'edit-template-page',
    pagetitledatatestid: 'edit-template-title',
    path: EDIT_MESSAGE_TEMPLATE_PATH,
    element: (
      <Page
        secondLevelData={settingsLevel}
        thirdLevelData={{
          title: generateSpanWithDataTestId(
            MESSAGE_TEMPLATES_LABEL,
            'templates-messages-page'
          ),
          path: MESSAGE_TEMPLATES_PATH,
        }}
      >
        <ManageMessageTemplate />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: CALENDAR_SETTINGS_KEY,
    label: CALENDAR_SETTINGS_LABEL,
    id: CALENDAR_SETTINGS_ID,
    pagebreadcrumbdatatestid: 'settings-calendar-page',
    pagetitledatatestid: 'settings-calendar-title',
    path: CALENDAR_SETTINGS_PATH,
    element: (
      <Page secondLevelData={settingsLevel}>
        <CalendarSettings />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: LOGS_REGISTRY_KEY,
    label: LOGS_REGISTRY_LABEL,
    id: LOGS_REGISTRY,
    path: LOGS_REGISTRY_PATH,
    element: (
      <Page
        secondLevelData={{
          title: SALES_FUNNELS_LABEL,
          path: SALES_FUNNELS_PATH,
        }}
      >
        <LogsRegistry />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SALES_FUNNELS,
  },
  {
    key: NOTIFICATIONS_KEY,
    label: NOTIFICATIONS_LABEL,
    id: NOTIFICATIONS,
    path: NOTIFICATIONS_PATH,
    pagebreadcrumbdatatestid: 'notifications-page',
    pagetitledatatestid: 'notifications-title',
    element: (
      <Page secondLevelData={settingsLevel}>
        <RecordNotifications />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },

  bookingPage,
  ...loyaltyPages,
  {
    key: INTEGRATIONS_PARSING_KEY,
    label: INTEGRATIONS_PARSING_LABEL,
    id: INTEGRATIONS_PARSING,
    [DATA_TESTID_ATTRIBUTE]: INTEGRATIONS_PARSING,
    path: '/integrations-parsing/:id',
    title: NO_TOOLTIP_TITLE,
    element: (
      <Page
        secondLevelData={{ title: INTEGRATIONS_LABEL, path: INTEGRATIONS_PATH }}
      >
        <IntegrationParsing />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_KEY,
    label: SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_LABEL,
    id: SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS,
    path: SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_PATH,
    title: NO_TOOLTIP_TITLE,
    element: (
      <Page
        secondLevelData={{
          title: SETTINGS_LABEL,
          path: SETTINGS_PATH,
        }}
      >
        <SettingUpAutomaticMessagingToClients />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: AI_PROMPTS_SETTINGS_KEY,
    label: AI_PROMPTS_SETTINGS_LABEL,
    id: AI_PROMPTS_SETTINGS,
    path: AI_PROMPTS_SETTINGS_PATH,
    title: NO_TOOLTIP_TITLE,
    element: (
      <Page
        secondLevelData={{
          title: SETTINGS_LABEL,
          path: SETTINGS_PATH,
        }}
      >
        <AiPromptsSettings />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: PAID_AI_FEATURES_KEY,
    label: PAID_AI_FEATURES_LABEL,
    id: PAID_AI_FEATURES,
    path: PAID_AI_FEATURES_PATH,
    title: NO_TOOLTIP_TITLE,
    element: (
      <Page
        secondLevelData={{
          title: SETTINGS_LABEL,
          path: SETTINGS_PATH,
        }}
      >
        <PaidAiFeatures />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: NEURAL_NETWORK_LOGS_SETTINGS_KEY,
    label: NEURAL_NETWORK_LOGS_SETTINGS_LABEL,
    id: NEURAL_NETWORK_LOGS_SETTINGS,
    path: NEURAL_NETWORK_LOGS_SETTINGS_PATH,
    element: (
      <Page
        secondLevelData={{
          title: CONTROL_PANEL_LABEL,
          path: CONTROL_PANEL_PATH,
        }}
      >
        <NeuralNetworkLogs />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: EMAIL_LOGS_SETTINGS_KEY,
    label: EMAIL_LOGS_SETTINGS_LABEL,
    id: EMAIL_LOGS_SETTINGS,
    path: EMAIL_LOGS_SETTINGS_PATH,
    element: (
      <Page
        secondLevelData={{
          title: CONTROL_PANEL_LABEL,
          path: CONTROL_PANEL_PATH,
        }}
      >
        <EmailLogs />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: CONTROL_PANEL,
  },
  {
    id: YOO_KASSA_SUCCESS_PAYMENT,
    label: YOO_KASSA_SUCCESS_PAYMENT_LABEL,
    path: YOO_KASSA_SUCCESS_PAYMENT_PATH,
    element: <YooKassaSuccessPayment />,
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: PAYMENT_DOCUMENTS_KEY,
    label: PAYMENT_DOCUMENTS_LABEL,
    id: PAYMENT_DOCUMENTS,
    path: PAYMENT_DOCUMENTS_PATH,
    element: (
      <Page
        headerContent={<PaymentDocumentsRegistryHeader />}
        secondLevelData={{
          title: CONTROL_PANEL_LABEL,
          path: CONTROL_PANEL_PATH,
        }}
      >
        <PaymentDocumentsRegistry />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: CONTROL_PANEL,
  },
  {
    key: ADD_PAYMENT_DOCUMENTS_KEY,
    label: ADD_PAYMENT_DOCUMENTS_LABEL,
    id: ADD_PAYMENT_DOCUMENTS,
    path: ADD_PAYMENT_DOCUMENTS_PATH,
    element: (
      <Page
        secondLevelData={{
          title: CONTROL_PANEL_LABEL,
          path: CONTROL_PANEL_PATH,
        }}
        thirdLevelData={{
          title: PAYMENT_DOCUMENTS_LABEL,
          path: PAYMENT_DOCUMENTS_PATH,
        }}
      >
        <AddPaymentDocument />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: CONTROL_PANEL,
  },
  {
    id: YOO_KASSA_PAYMENT_WITH_EMAIL,
    label: YOO_KASSA_PAYMENT_WITH_EMAIL_LABEL,
    path: YOO_KASSA_PAYMENT_WITH_EMAIL_PATH,
    element: <YooKassaPaymentWithEmail />,
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: DETACH_RESPONSIBLE_FROM_LEAD_KEY,
    label: DETACH_RESPONSIBLE_FROM_LEAD_LABEL,
    id: DETACH_RESPONSIBLE_FROM_LEAD,
    path: DETACH_RESPONSIBLE_FROM_LEAD_PATH,
    element: (
      <Page secondLevelData={settingsLevel}>
        <DetachResponsibleFromLead />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  ...warehousesPages,
  ...duplicateClientsPages,
  ...clientsPages,
  {
    key: ORGANIZATION_ANALYTICS_KEY,
    icon: (
      <FontAwesomeIcon
        icon={'fa-solid fa-bars' as IconProp}
        size="sm"
        className="location-icon"
      />
    ),
    label: ORGANIZATION_ANALYTICS_LABEL,
    id: ORGANIZATION_ANALYTICS,
    path: ORGANIZATION_ANALYTICS_PATH,
    title: NO_TOOLTIP_TITLE,
    element: (
      <Page
        secondLevelData={{
          title: ORGANIZATIONS_LABEL,
          path: ORGANIZATIONS_PATH,
        }}
      >
        <OrganizationAnalytics />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: ORGANIZATIONS,
  },
  {
    key: MEDICAL_CARD_REGISTRY_KEY,
    icon: (
      <FontAwesomeIcon
        icon={'fa-solid fa-briefcase-medical' as IconProp}
        size="sm"
        className="location-icon"
      />
    ),
    label: MEDICAL_CARD_REGISTRY_LABEL,
    id: MEDICAL_CARD_REGISTRY,
    path: MEDICAL_CARD_REGISTRY_PATH,
    title: NO_TOOLTIP_TITLE,
    servicerightsid: RIGHTS_MEDICAL_DOCUMENTS,
    element: (
      <Page>
        <MedicalCardRegistry />
      </Page>
    ),
    issidebaritem: 'true',
    sidebarparentid: MEDICAL_CARD_REGISTRY,
  },
  {
    key: DOCUMENT_TEMPLATES_KEY,
    label: DOCUMENT_TEMPLATES_LABEL,
    id: DOCUMENT_TEMPLATES,
    path: DOCUMENT_TEMPLATES_PATH,
    pagebreadcrumbdatatestid: 'document-templates-page',
    pagetitledatatestid: 'document-templates-title',
    element: (
      <Page secondLevelData={settingsLevel}>
        <DocumentTemplates />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  billingPage,
];
